export function useAppInfo() {
  return { appInfo: window.info };
}
